import { validarSesion } from "./Auth";
const config = require("../env.json");

export const obtenerListaMaestraDatos=async(token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/listamaestra/`;
    const resp=await fetch(
        url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        });
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;

};
